import './bootstrap';

// Externals
import './wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
import './wwdev/lazysizes/index.js';
import './externals/slick/slick.min'
import 'magnific-popup'
import 'imagesloaded';
import 'jquery.counterup';
import 'waypoints/lib/jquery.waypoints';
import 'jquery-nice-select';
import 'jquery-ui/dist/jquery-ui';
import './externals/calendar';
import './externals/theme.js';
import EqualHeights from "./externals/EqualHeights";
new EqualHeights()

// Base
import './base/LanguageSwitcher';
import './base/cookiebar';

// Components
import './components/index';
import CriteriaToggle from "./components/CriteriaToggle";
//import './components/reflex';

